export default __webpack_public_path__ + "static/reed-4-e46382b1f7dc5755ed53b567e170e037.png";